<div *ngIf="!!backgroundImage && !vimeoId" class="content-padding background aspect-ratio-box-3-2" [ngClass]="{'h-100': fillHeight, 'limit-max-height': !fillHeight}" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')', 'box-shadow': 'rgba(0, 0, 0, ' + overlayOpacity + ') 0 0 0 1000px inset'}">
  <div class="container m-0 p-0">
    <ng-content></ng-content>
  </div>
</div>

<!--<div *ngIf="!!vimeoId">-->
<!--  <div class="video">-->
<!--    <iframe scrolling="no" class="cover-image-background embed-responsive-item video" [style.background-url]="safeStyle('url(' + backgroundImage + ')')" [src]="'https://player.vimeo.com/video/' + vimeoId + '?background=1&autoplay=1&loop=1&byline=0&title=0&dnt=1' | html:'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted allowtransparency="true" aria-label="home page video">-->
<!--      <div class="container m-0 p-0">-->
<!--        <ng-content></ng-content>-->
<!--      </div>-->
<!--    </iframe>-->
<!--  </div>-->
<!--</div>-->
